import h from 'react-hyperscript';

const Section = props => {
  const { id = '', className = '', children = [] } = props;

  return h('section.main-section', { id, className }, [h('.container', {}, children)]);
};

export default Section;



// WEBPACK FOOTER //
// ./src/components/Section/Section.js